import React from "react"
import * as styles from './Covid.module.scss'

import SimpleButton from './../../UI/Buttons/SimpleButton/SimpleButton'

const GeneralCovidAlert = ({clickHandler}) => {

    return(
        <section className={`${styles.alertWrap}`}>
            <div className={`${styles.alertWidthContraints}`}>
                <div className={`${styles.alert_content}`}>
                    <span>Covid-19 Updates &amp; Resources</span>
                    <SimpleButton text='More On Our Efforts' url='/covid-response/' type='solidRed' />
                </div>
                <div>
                    <button className={`${styles.alert_dismissBtn}`} aria-label='Dismiss Alert' onClick={clickHandler}>X</button>
                </div>
            </div>
        </section>
    )
}

export default GeneralCovidAlert